import { Routes } from './interfaces/route';
import { AuthGuard } from './auth.guard';
import { HRAuthGuard } from './views/personnel/hrauth.guard';
import { NotFoundComponent } from './components/not-found/not-found.component';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./views/authentication/authentication-views.module').then((m) => m.AuthenticationModule)
  },
  {
    path: 'assets',
    loadChildren: () => import('./views/assets/assets-views.module').then((m) => m.AssetViewsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'bra',
    loadChildren: () => import('./views/bra/bra-views.module').then((m) => m.BraViewsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'calendar',
    loadChildren: () => import('./views/calendar/calendar-views.module').then((m) => m.CalendarModule),
    canActivate: [AuthGuard],
    data: {
      capabilities: ["calendar.view"]
    }
  },
  {
    path: 'emergency',
    loadChildren: () => import('./views/emergency/emergency-views.component').then((m) => m.EmergencyViewsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'equipment',
    loadChildren: () => import('./views/equipment/equipment.module').then((m) => m.EquipmentModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'history',
    loadComponent: () => import('./views/history/history.component').then((m) => m.HistoryComponent),
    canActivate: [AuthGuard],
    data: {
      capabilities: ["history.view"]
    }
  },
  {
    path: 'inspector',
    loadChildren: () => import('./views/inspector/inspector-views.module').then((m) => m.InspectorViewsModule),
    canActivate: [AuthGuard],
    data: {
      capabilities: ["inspector.view"]
    }
  },
  {
    path: 'management',
    loadChildren: () => import('./views/management/management-views.module').then((m) => m.SMVViewsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'my',
    loadChildren: () => import('./views/my/my-views.module').then((m) => m.MyViewsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'notifications',
    loadChildren: () => import('./views/notifications/notification-views.module').then((m) => m.NotificationViewsModule),
    canActivate: [AuthGuard]
  },

  {
    path: 'surveys',
    loadChildren: () => import('./views/surveys/survey-views.module').then((m) => m.SurveyViewsModule),
    canActivate: [AuthGuard]
  },

  {
    path: 'personnel',
    loadChildren: () => import('./views/personnel/personnel-views.module').then((m) => m.PersonnelViewsModule),
    canActivate: [AuthGuard, HRAuthGuard],
    data: {
      hrRequiresElevation: true
    }
  },
  {
    path: 'process-history',
    loadComponent: () => import('./views/process-history/process-history.component').then((m) => m.ProcessHistoryComponent),
    canActivate: [AuthGuard],
    data: {
      capabilities: ["all"]
    }
  },
  {
    path: 'support',
    loadChildren: () => import('./views/support/support-views.module').then((m) => m.SupportViewsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'user',
    loadChildren: () => import('./views/user/user-views.module').then((m) => m.UserModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'vessel',
    loadChildren: () => import('./views/site-vessel/site-views.module').then((m) => m.SiteViewsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'visits-reports',
    loadChildren: () =>
      import('./views/visits-reports/visit-report-views.module').then((m) => m.VisitReportViewsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'warehouse',
    loadChildren: () => import('./views/warehouse/warehouse.module').then((m) => m.WarehouseViewsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'yard',
    loadChildren: () => import('./views/yard/yard-views.module').then((m) => m.YardViewsModule),
    canActivate: [AuthGuard]
  },
  { path: '', redirectTo: '/user/dashboard', pathMatch: 'full' },
  { path: 'not-found', component: NotFoundComponent },
  {
    path: '**',
    loadComponent: () => import('./components/not-found/not-found.component').then((m) => m.NotFoundComponent)
  }
];
